export const getOrderLines = (order, orderKey) => {
  if (!order || !orderKey) {
    return [];
  }

  const orderValue = order[orderKey];

  if (Array.isArray(orderValue)) {
    return orderValue
      .map(item => {
        if (typeof item === 'string') {
          return item.trim();
        }

        return '';
      })
      .filter(Boolean);
  }

  return String(orderValue || '')
    .split('\n')
    .map(item => item.trim())
    .filter(Boolean);
};

export const getDiagnosisLines = order => {
  if (!order) {
    return [];
  }

  const diagnosisValue =
    order.diagnosis ||
    order.diagnoses;

  if (Array.isArray(diagnosisValue)) {
    return diagnosisValue
      .map(item => {
        if (typeof item === 'string') {
          return item.trim();
        }

        if (
          item &&
          typeof item === 'object'
        ) {
          const code = item.code || '';
          const description =
            item.description || '';

          if (code && description) {
            return `${code} - ${description}`;
          }

          if (code) {
            return code;
          }

          if (description) {
            return description;
          }
        }

        return '';
      })
      .filter(Boolean);
  }

  return String(diagnosisValue || '')
    .split('\n')
    .map(item => item.trim())
    .filter(Boolean);
};